(function () {
    'use strict';

    angular
        .module('app')
        .controller('adminoptions', adminoptions);

    adminoptions.$inject = ['$location', '$mdDialog', 'sidebarservice', 'loginService', '$rootScope', 'zcs', '$q', 'clientService'];

    function adminoptions($location, $mdDialog, sidebarservice, loginService, $rootScope, zcs, $q, clientService) {
        /* jshint validthis:true */
        var vm = this;
        vm.clientService = clientService;

        vm.windows = bowser.windows;

        vm.adminOptionsLabel = loginService.resourceStrings["ADMIN_SETTINGS"]; // "Admin Settings"
        vm.userSettingsLabel = loginService.resourceStrings["USER_SETTINGS"]; // "User Settings"
        vm.otherLabel = loginService.resourceStrings["OTHER"]; // "Other"

        vm.uploadSettingsLabel = loginService.resourceStrings["UPLOAD_SETTINGS"]; // "Upload Settings"
        vm.changeUploadLocationLabel = loginService.resourceStrings["CHANGE_UPLOAD_LOCATION"]; // Change upload location and notification e-mail	
        vm.editableFieldsLabel = loginService.resourceStrings["EDITABLE_FIELDS"]; // "Editable Fields"
        vm.editableFieldsDetailLabel = loginService.resourceStrings["EDITABLE_FIELDS_DETAIL"]; // "Change fields that can be edited in the Data Card"

        vm.localViewerOptionsLabel = loginService.resourceStrings["LOCAL_VIEWER_OPTIONS"]; // "Local Viewer Options"
        vm.localViewerOptionsDetailLabel = loginService.resourceStrings["LOCAL_VIEWER_OPTIONS_DETAIL"]; // "Configure File Extensions that use the Local Viewer."

        vm.systemOptionsLabel = loginService.resourceStrings["SYSTEM_OPTIONS"]; // "System Options"
        vm.systemOptionsDetailLabel = loginService.resourceStrings["SYSTEM_OPTIONS_DETAIL"]; // "System-wide administration options."

        vm.ftsOptionsLabel = loginService.resourceStrings["FTS_OPTIONS"]; // "Full Text Search Options"
        vm.ftsOptionsDetailLabel = loginService.resourceStrings["FTS_OPTIONS_DETAIL"]; // "Full Text Search administration options."

        if (loginService.creator == true) {
            vm.vlBasePathLabel = loginService.resourceStrings["LOCAL_VIRTUAL_LIBRARY_PATH"]; // "Local Virtual Library Path";
            vm.vlBasePathDetailLabel =  loginService.resourceStrings["LOCAL_VIRTUAL_LIBRARY_PATH_DETAIL"]; // "Local Path for copies of files that are not in the work area.";
        }
        else {
            vm.vlBasePathHidden = true;
        }

        vm.documentDashboardDisplayLabel = loginService.resourceStrings["DOCUMENT_DASHBOARD_DISPLAY"]; // "Local Virtual Library Path";
        vm.documentDashboardDisplayDetailLabel = loginService.resourceStrings["DOCUMENT_DASHBOARD_DISPLAY_DETAIL"]; // "Local Path for copies of files that are not in the work area.";

        vm.userViewerSettingsDisplayLabel = loginService.resourceStrings["VIEWER_USER_SETTINGS_TAB_LABEL"];
        vm.userViewerSettingsDisplayDetailLabel = loginService.resourceStrings["VIEWER_USER_SETTINGS_DETAIL_LABEL"];

        vm.sidebarservice = sidebarservice;
        vm.mdDialog = $mdDialog;
        vm.activeTab = loginService.isAdmin ? 0 : 1;
        vm.loginService = loginService;

        var dialogController = function (scope) {
            scope.onOK = function () {
                /* Called by the adminOptions controller */
                vm.mdDialog.hide();
            }
            scope.onCancel = function () {
                /* Called by the adminOptions controller */
                vm.mdDialog.cancel();
            }
        }

        vm.changeTab = function (tab) {
            vm.activeTab = tab;
        }

        vm.onShowAdminOptionUpload = function () {
            // Check if still logged in.
            loginService.isLoggedIn().then(function (data) {
                vm.mdDialog.show({
                    controller: dialogController,
                    templateUrl: "app/options/templates/adminUpload.html",
                    clickOutsideToClose: false,
                    fullscreen: false,
                    parent: angular.element(document.body)
                });
            }, function (data) {
                //$state.go("login");
            }); // Not logged in.
        }

        vm.showEditableFields = function () {
            // Check if still logged in.
            loginService.isLoggedIn().then(function (data) {
                vm.mdDialog.show({
                    controller: 'editableFields',
                    controllerAs: 'vm',
                    templateUrl: "app/options/templates/adminEditableFields.html",
                    clickOutsideToClose: false,
                    fullscreen: false,
                    parent: angular.element(document.body)
                });
            }, function (data) { $state.go("login"); }); // Not logged in.
        }

        vm.showLocalViewerOptionsDialog = function () {
            // Check if still logged in.
            loginService.isLoggedIn().then(function (data) {
                vm.mdDialog.show({
                    controller: 'localViewerOptions',
                    controllerAs: 'vm',
                    templateUrl: "app/options/templates/adminLocalViewer.html",
                    clickOutsideToClose: false,
                    fullscreen: false,
                    parent: angular.element(document.body)
                });
            }, function (data) {
                //$state.go("login");
            }); // Not logged in.
        }

        vm.showSystemOptionsDialog = function () {
            // Check if still logged in.
            loginService.isLoggedIn().then(function (data) {
                vm.mdDialog.show({
                    controller: 'systemOptions',
                    controllerAs: 'vm',
                    templateUrl: "app/options/templates/adminSystem.html",
                    clickOutsideToClose: false,
                    fullscreen: false,
                    parent: angular.element(document.body)
                });
            }, function (data) { $state.go("login"); }); // Not logged in.
        }

        vm.showFtsOptionsDialog = function () {
            // Check if still logged in.
            loginService.isLoggedIn().then(function (data) {
                vm.mdDialog.show({ 
                    controller: 'ftsOptions', //'ftsOptions',
                    controllerAs: 'vm',
                    templateUrl: "app/options/templates/adminFts.html", //"app/options/templates/adminFts.html",
                    clickOutsideToClose: false,
                    fullscreen: false,
                    parent: angular.element(document.body)
                });
            }, function (data) { $state.go("login"); }); // Not logged in.
        }

        // =============================
        // BEGIN - VL BASE PATH
        // =============================

        // Callback from the input box before the box closes.
        var vlBasePathBrowseFolderBoxPreClosePromiseCallback = function (param1, param2, bOK, edit1, driveType, edit2) {
            var deferred = $q.defer();
            if (bOK) {
                zcs.SetLocalVirtualLibraryPath(edit1).then(function (data) {
                    deferred.resolve(data); // True to close.
                }, function (response) {
                    $rootScope.msgBoxShow(response.data.Message, loginService.resourceStrings["ERROR"]);
                    deferred.reject(response); // False to stop the close.
                });
            }
            else {
                deferred.resolve(); // True to close (after a Cancel).
            }
            return deferred.promise;
        }

        vm.showVLBasePathDialog = function () {
            // Check if still logged in.
            loginService.isLoggedIn().then(function (data) {
                // Ping ACS. On failure, just show error.
                zcs.Ping(true).then(function (response) {
                    //vm.mdDialog.show({
                    //    controller: 'systemOptions',
                    //    controllerAs: 'vm',
                    //    templateUrl: "app/options/templates/adminSystem.html",
                    //    clickOutsideToClose: false,
                    //    fullscreen: false,
                    //    parent: angular.element(document.body)
                    //});
                    zcs.GetLocalVirtualLibraryPath().then(function (data) {
                        var title = vm.vlBasePathLabel;
                        var prompt1 = vm.vlBasePathLabel;
                        var driveType = ' '; // ApiTypes.WA_DRIVETYPE.WA_DRIVEUNKNOWN
                        // Show the UI.
                        $rootScope.browseFolderBoxShow("", "", title, prompt1, "", data, driveType, "", "", vlBasePathBrowseFolderBoxPreClosePromiseCallback, null, 0);
                    });
                }, function () {
                    // Handle error.
                    $mdDialog.hide();
                    $rootScope.msgBoxShow(loginService.resourceStrings["ACS_FAILED_TO_CONNECT"], loginService.resourceStrings["ACS_REQUIRED"]);
                });
            }, function (data) {
                //$state.go("login");
            }); // Not logged in.
        }

        // =============================
        // END - VL BASE PATH
        // =============================

        vm.showDocumentDashboardDialog = function () {
            // Check if still logged in.
            loginService.isLoggedIn().then(function (data) {
                vm.mdDialog.show({
                    controller: 'documentDashboardOptions',
                    controllerAs: 'vm',
                    templateUrl: "app/options/templates/documentDashboard.html",
                    clickOutsideToClose: false,
                    fullscreen: false,
                    parent: angular.element(document.body)
                });
            }, function (data) {
                //$state.go("login");
            }); // Not logged in.
        }

        vm.showViewerUserSettingsDialog = function () {
            // Check if still logged in.
            loginService.isLoggedIn().then(function (data) {
                vm.mdDialog.show({
                    controller: 'viewerUserSettings',
                    controllerAs: 'vm',
                    templateUrl: "app/options/templates/viewerUserSettings.html",
                    clickOutsideToClose: false,
                    fullscreen: false,
                    parent: angular.element(document.body)
                });
            }, function (data) {
                //$state.go("login");
            }); // Not logged in.
        }

        vm.showACSDownloadOptions = function () {
            clientService.showDownloadDialog('download');
        }


        //hide the sidebar when going to the login page.
        $rootScope.$on("$stateChangeStart", function (event, toState, toParams) {
            if (toState.name == "login") {
                sidebarservice.rightSideBarOpen = false;
                vm.mdDialog.hide();
            }
        });
    }
})();
